import moment, { Moment } from "moment"
import { GenerateConfig } from "rc-picker/lib/generate"
import momentGenerateConfig from "rc-picker/lib/generate/moment"

export const utcMomentGenerateConfig: GenerateConfig<Moment> = {
  ...momentGenerateConfig,
  getNow: () => moment.utc(),
  getFixedDate: date => moment.utc(date, "YYYY-MM-DD"),
  locale: {
    ...momentGenerateConfig.locale,
    parse: (locale, text, formats) => {
      const date = formats.map(format => moment.utc(text, format, locale, true)).find(parsed => parsed.isValid())

      return date ?? null
    },
  },
}
